var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPrivate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/General/Users Copy 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7741 5.4167V8.85423C16.0922 8.85423 17.1613 9.88033 17.1613 11.1458V16.8749C17.1613 18.1407 16.0922 19.1667 14.7741 19.1667H5.22558C3.90716 19.1667 2.83838 18.1407 2.83838 16.8749V11.1458C2.83838 9.88037 3.90716 8.85423 5.22558 8.85423V5.4167C5.22558 2.89007 7.36739 0.833328 9.99984 0.833328C12.633 0.833328 14.7741 2.89007 14.7741 5.4167ZM7.61244 8.85423H12.3866V5.4167C12.3866 4.15225 11.3155 3.12498 9.99957 3.12498C8.68299 3.12498 7.61244 4.15225 7.61244 5.4167V8.85423Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPrivate);
export default __webpack_public_path__ + "static/media/icPrivate.c4eec9f7dc24c972247c081f713124a0.svg";
export { ForwardRef as ReactComponent };